export default {
	label: 'Version',
	links: [
		{
			id: 0,
			url: 'https://didacticiel.ameli.fr/assures/cgu_mentionslegales/#conditions-generales-dutilisation',
			name: 'Mentions légales et CGU',
			title: 'Mentions légales et CGU (nouvelle fenêtre)'
		},
		{
			id: 1,
			url: 'https://didacticiel.ameli.fr/assures/cgu_mentionslegales/#accessibilite',
			name: 'Aide et Accessibilité',
			title: 'Aide et Accessibilité (nouvelle fenêtre)'
		},
		{
			id: 2,
			url: 'https://didacticiel.ameli.fr/assures/cgu_mentionslegales/#recommandations-de-securite',
			name: 'Recommandations de sécurité',
			title: 'Recommandations de sécurité (nouvelle fenêtre)'
		},
		{
			id: 3,
			url: 'https://didacticiel.ameli.fr/assures/cgu_mentionslegales/#conditions-generales-dutilisation',
			name: 'Protection des données personnelles',
			title: 'Protection des données personnelles (nouvelle fenêtre)'
		},
		{
			id: 4,
			url: 'https://www.ameli.fr/',
			name: 'Site Ameli',
			title: 'Site Ameli (nouvelle fenêtre)'
		}
	]
};
